import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import ProcessorModal from '.'
import { selectAllFields, selectCompletedFields } from '../slices/formInstanceSlice'
import { selectWorkflowType } from 'components/QuestionnaireRequestAutomated/processor/slices/globalSlice'
import { clsx } from 'clsx'

const ReviewItem = ({ iconClassName, title, children }) => {
  return (
    <li className="dome-d-flex dome-gap6">
      <span>
        <i className={iconClassName}></i>
      </span>
      <div className="dome-d-flex dome-flex-column dome-gap3">
        <span className="dome-p2 dome-color-darkest-grey">{title}</span>
        {children}
      </div>
    </li>
  )
}

export default function SubmitCautionModal({
  open = false,
  onClose = () => {},
  onSubmit = () => {},
  submitting = false,
}) {
  // const numberIncompletedFields = useSelector(selectIncompletedFields).length
  // const numberMarkedNaFields = useSelector(selectMarkedNaFields).length
  const numberCompletedFields = useSelector(selectCompletedFields).length
  const allFields = useSelector(selectAllFields)
  const numberAllFields = useMemo(() => Object.keys(allFields)?.length, [allFields])
  const workflowType = useSelector(selectWorkflowType)
  const { autoArchive, respondingFiles } = useSelector((state) => state.global)

  // const [sendCopy, setSendCopy] = useState(false)

  return (
    <ProcessorModal open={open} onClose={onClose}>
      <div className='dome-bg-white' style={{ padding: '36px 60px 24px 60px', borderRadius: 6 }}>
        <div className="dome-d-flex dome-flex-column dome-gap24">
          <div className="dome-d-flex dome-flex-column dome-gap12">
            <span>
              <i style={{ fontSize: '50px' }} className="fa-light fa-magnifying-glass dome-color-dark-green"></i>
            </span>
            <span className="dome-h2 dome-color-dark-green">please review before sending</span>
          </div>
          <div style={{ width: 380 }} className="dome-d-flex dome-flex-column dome-gap18">
            {/*<span className="dome-p2 dome-color-darkest-grey">questionnaire name</span>*/}
            <ul
              style={{ listStyle: 'none', padding: 0, margin: 0 }}
              className="dome-d-flex dome-flex-column dome-gap12"
            >
              {workflowType === 'automated' && (
                <>
                  <ReviewItem iconClassName="fa-light fa-pen-field" title="fields">
                    <span className="dome-p3 dome-color-dark-grey">
                      {`${numberCompletedFields}/${numberAllFields} completed`}
                    </span>
                  </ReviewItem>
                  <ReviewItem iconClassName="fa-light fa-signature" title="signature">
                    <span className="dome-p3 dome-color-dark-grey">signed on 00/00/00</span>
                  </ReviewItem>
                </>
              )}
              <ReviewItem iconClassName="fa-light fa-paperclip" title="attachments">
                {respondingFiles.map((file, index) => (
                  <span className="dome-p3 dome-color-dark-grey" key={index}>
                    {file.original_filename}
                  </span>
                ))}
              </ReviewItem>
            </ul>
            {/*
            <div className="dome-d-flex dome-gap12 dome-align-center">
              <input
                style={{ margin: 0 }}
                type="checkbox"
                id="sendCopy"
                checked={sendCopy}
                onChange={(e) => setSendCopy(e.target.checked)}
              />
              <label style={{ margin: 0 }} htmlFor="sendCopy" className="dome-p3 dome-color-dark-grey">
                Send me a copy of the compiled PDF after it's sent.
              </label>
            </div>
              */}
          </div>
          <div className="dome-d-flex dome-justify-between">
            <button
              type="button"
              onClick={onClose}
              className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
            >
              back
            </button>
            <button
              type="button"
              onClick={onSubmit}
              disabled={submitting}
              className={clsx('dome-btn dome-btn-base dome-btn-dark-green', submitting && 'dome-btn-disabled')}
            >
              { autoArchive ? 'send & archive questionnaire' : 'send questionnaire'}
            </button>
          </div>
        </div>
      </div>
    </ProcessorModal>
  )
}
